var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMerged2Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6048_52692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 22.4986H7.8326V15.166C3.7802 15.166 0.5 18.4528 0.5 22.4986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 22.498H0.5V29.8306C4.5524 29.8306 7.8326 26.5504 7.8326 22.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 44.5025H7.8326V37.1699C3.7802 37.1699 0.5 40.4501 0.5 44.5025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 44.502H0.5V51.8346H7.8326V44.502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 51.834H0.5V59.1666H7.8326V51.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83203 37.1693H15.1646V29.8301C11.1188 29.8301 7.83203 33.1169 7.83203 37.1693Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1646 51.834H7.83203V59.1666C11.8844 59.1666 15.1646 55.8798 15.1646 51.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1641 15.1646H22.4967V7.83203C18.4509 7.83203 15.1641 11.1188 15.1641 15.1646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4967 15.166H15.1641V22.4986C19.2165 22.4986 22.4967 19.2184 22.4967 15.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4967 29.8301H15.1641V37.1627H22.4967V29.8301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4967 37.1699H15.1641V44.5025C19.2165 44.5025 22.4967 41.2157 22.4967 37.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8314 0.5H26.1618C24.1356 0.5 22.4922 2.1434 22.4922 4.1696V7.8392H26.1618C28.188 7.8392 29.8314 6.1958 29.8314 4.1696",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 29.8306H29.8326V22.498C25.7868 22.498 22.5 25.7848 22.5 29.8306Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 59.1666H29.8326V51.834C25.7868 51.834 22.5 55.1142 22.5 59.1666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8281 15.1646H37.1607V7.83203C33.1149 7.83203 29.8281 11.1188 29.8281 15.1646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 15.166H29.8281V22.4986H37.1607V15.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 22.498H29.8281V29.8306H37.1607V22.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 51.834H29.8281V59.1666H37.1607V51.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 59.168H29.8281V66.5006H37.1607V59.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1719 7.8326H44.5045V0.5C40.4521 0.5 37.1719 3.7802 37.1719 7.8326Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 7.83203H37.1719V15.1646C41.2177 15.1646 44.5045 11.8844 44.5045 7.83203Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 22.498H37.1719V29.8306C41.2177 29.8306 44.5045 26.5504 44.5045 22.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1719 44.5025H44.5045V37.1699C40.4521 37.1699 37.1719 40.4501 37.1719 44.5025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 44.502H37.1719V51.8346H44.5045V44.502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 59.168H37.1719V66.5006H44.5045V59.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 0.5H44.5V7.8326H51.8326V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 22.4986H51.8326V15.166C47.7802 15.166 44.5 18.4528 44.5 22.4986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8353 29.8301H48.1657C46.1395 29.8301 44.4961 31.4735 44.4961 33.4997V37.1693H48.1657C50.1919 37.1693 51.8353 35.5259 51.8353 33.4997",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 44.502H44.5V51.8346C48.5458 51.8346 51.8326 48.5478 51.8326 44.502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 59.168H44.5V66.5006H51.8326V59.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1685 0.5H51.8359V7.8326C55.8817 7.8326 59.1685 4.5524 59.1685 0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1685 15.166H51.8359V22.4986C55.8817 22.4986 59.1685 19.2184 59.1685 15.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8359 44.5025H59.1685V37.1699C55.1161 37.1699 51.8359 40.4501 51.8359 44.5025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8359 59.1666H59.1685V51.834C55.1161 51.834 51.8359 55.1142 51.8359 59.1666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.168 29.8306H66.5006V22.498C62.4482 22.498 59.168 25.7848 59.168 29.8306Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5006 29.8301H59.168V37.1627H66.5006V29.8301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5006 37.1699H59.168V44.5025C63.2204 44.5025 66.5006 41.2157 66.5006 37.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1685 59.168H51.8359V66.5006C55.8817 66.5006 59.1685 63.2204 59.1685 59.168Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6048_52692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerged2Icon);
export default __webpack_public_path__ + "static/media/merged-2-icon.f3c188d8207b2016dd8bd0f67c7b5474.svg";
export { ForwardRef as ReactComponent };